import Vue from "vue";
import Router from "vue-router";
import Bus from "utils/bus.js";
import Axios from "axios";
import apiAxios from "@/utils/Axios";
import { Message } from "element-ui";

Vue.use(Router);


// 解决前端多次点击相同路由 Navigating to current location ("/XXX") is not allowed 问题
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
};

import homePage from "pages/homePage";
import loginPage from "pages/login/index.vue";
import newloginPage from "../views/login";
import newhome from "../views/home";
import Axios2 from "@/utils/Axios";
import singlehome from "../views/singlehome";
import testpage from "pages/login/testPage";
const home = [
  {
    path: "/",
    redirect: "/newlogin",
  },

  {
    path: "/singlehome",
    component: singlehome,
  },
  {
    path: "/showpage",
    component: testpage,
  },
  {
    path: "/login",
    component: loginPage,
  },
  {
    path: "/newlogin",
    component: newloginPage,
  },
  {
    path: "/newhome",
    component: newhome,
  },
  {
    path: "/imclogin",
    component: (resolve) => {
      require(["../pages/login/ImcLogin"], resolve);
    },
  },
  {
    path: "/bslogin",
    component: (resolve) => {
      require(["../pages/login/bsLogin"], resolve);
    },
  },
  {
    name: "personalCenter",
    path: "/personalCenter",
    component: (resolve) => {
      require(["../pages/personalCenterPage/index"], resolve);
    },
  },

  {
    name: "disclaimer",
    path: "/disclaimer",
    component: (resolve) => {
      require(["../pages/saveRule/disclaimer"], resolve);
    },
  },
  {
    name: "saverule",
    path: "/saveRule",
    component: (resolve) => {
      require(["../pages/saveRule/PrivacyPolicy"], resolve);
    },
  },
  {
    path: "/home",
    component: homePage,
    children: [
      //个人用户首页
      {
        name: "singeruerPage",
        path: "/singerUer",
        component: (resolve) =>
          require(["../pages/mainPage/singleUser"], resolve),
      },
      {
        name: "watchCenterPage",
        path: "/watchCenter",

        component: (resolve) => require(["../pages/watchCenterPage"], resolve),
        children: [
          {
            name: "stationListPage",
            path: "/stationList",
            meta: { keepAlive: true }, //
            component: (resolve) =>
              require(["../pages/stationManagePage/stationList"], resolve),
          },
          {
            name: "stationDetailPage",
            path: "/stationDetail",
            meta: { keepAlive: false }, //
            component: (resolve) =>
              require(["../pages/stationManagePage/stationDetail"], resolve),
          },
          {
            name: "reportPage",
            path: "/reportList",
            component: (resolve) =>
              require(["../pages/saveReportPage/reportList"], resolve),
          },

          {
            name: "powerWatchPage",
            path: "/powerWatch",
            component: (resolve) =>
              require(["../pages/powerWatch"], resolve),
          },
          {
            name: "reportdetailPage",
            path: "/reportDetail",
            component: (resolve) =>
              require(["../pages/saveReportPage/reportDetail"], resolve),
          },
          {
            name: "newReport",
            path: "/newReport",
            component: (resolve) =>
              require(["../pages/saveReportPage/newReport"], resolve),
          },
          {
            name: "dataDetailPage",
            path: "/dataDetail",
            meta: { keepAlive: false }, //
            component: (resolve) =>
              require(["../pages/stationManagePage/dataDetail"], resolve),
          },
          {
            name: "dataList",
            path: "/dataList",
            meta: { keepAlive: true }, //
            component: (resolve) =>
              require(["../pages/stationManagePage/dataList"], resolve),
          },
        ],
      },

      //异常中心
      {
        name: "unusualCenterPage",
        path: "/unusualCenter",
        component: (resolve) =>
          require(["../pages/unusualCenterPage"], resolve),
        children: [
          {
            name: "electroWarnPage",
            path: "/electricWarn",
            component: (resolve) => {
              require([
                "@/pages/unusualCenterPage/components/electricWarn.vue",
              ], resolve);
            },
          },
          {
            name: "environmentWarnPage",
            path: "/environmentWarn",
            component: (resolve) => {
              require([
                "@/pages/unusualCenterPage/components/environmentWarn.vue",
              ], resolve);
            },
          },
          {
            name: "hiddenWarnPage",
            path: "/hiddenWarn",
            component: (resolve) => {
              require([
                "@/pages/unusualCenterPage/components/hiddenWarn.vue",
              ], resolve);
            },
          },
        ],
      },
      //设备中心
      {
        name: "deviceCenterPage",
        path: "/deviceCenter",
        component: (resolve) => require(["../pages/deviceCenterPage"], resolve),
        children: [
          {
            name: "deviceMangerPage",
            path: "/deviceManger",
            component: (resolve) => {
              require([
                "@/pages/deviceCenterPage/components/deviceManger",
              ], resolve);
            },
          },
          {
            name: "deviceOpsPage",
            path: "/deviceOps",
            component: (resolve) => {
              require([
                "@/pages/deviceCenterPage/components/deviceOps",
              ], resolve);
            },
          },
        ],
      },
      //打标管理
      {
        name: "godPage",
        path: "/godManger",
        component: (resolve) => require(["../pages/godPage"], resolve),
        children: [
          {
            name: "godGetPage",
            path: "/godGetPage",
            component: (resolve) => {
              require([
                "@/pages/godPage/components/components/godGetPage",
              ], resolve);
            },
          },
          {
            name: "godReturnPage",
            path: "/godReturnPage",
            component: (resolve) => {
              require([
                "@/pages/godPage/components/components/godReturnPage",
              ], resolve);
            },
          },
        ],
      },

      //配置管理
      {
        name: "configCenterPage",
        path: "/configCenter",
        component: (resolve) => require(["../pages/configCenterPage"], resolve),
        children: [
          {
            name: "userMangerPage",
            path: "/userManage",
            component: (resolve) => {
              require([
                "@/pages/configCenterPage/components/userManage",
              ], resolve);
            },
          },
          {
            name: "sendManger",
            path: "/sendManger",
            component: (resolve) => {
              require([
                "@/pages/configCenterPage/components/sendManange",
              ], resolve);
            },
          },
          {
            name: "roleMangerPage",
            path: "/roleManage",
            component: (resolve) => {
              require([
                "@/pages/configCenterPage/components/roleManage",
              ], resolve);
            },
          },
          {
            name: "riskMangerPage",
            path: "/riskManage",
            component: (resolve) => {
              require([
                "@/pages/configCenterPage/components/riskManage",
              ], resolve);
            },
          },
          {
            name: "orgMangerPage",
            path: "/orgManage",
            component: (resolve) => {
              require([
                "@/pages/configCenterPage/components/orgManage",
              ], resolve);
            },
          },
          {
            name: "appMangerPage",
            path: "/AppManage",
            component: (resolve) => {
              require([
                "@/pages/configCenterPage/components/AppManage",
              ], resolve);
            },
          },
          {
            name: "rentMangerPage",
            path: "/rentManage",
            component: (resolve) => {
              require([
                "@/pages/configCenterPage/components/rentManage",
              ], resolve);
            },
          },
          {
            name: "hiddenMangerPage",
            path: "/hiddenManage",
            component: (resolve) => {
              require([
                "@/pages/configCenterPage/components/hiddenManage",
              ], resolve);
            },
          },
          {
            name: "noteMangerPage",
            path: "/noteManage",
            component: (resolve) => {
              require([
                "@/pages/configCenterPage/components/noteManage",
              ], resolve);
            },
          },
          {
            name: "partMangerPage",
            path: "/partManage",
            component: (resolve) => {
              require([
                "@/pages/configCenterPage/components/partManage",
              ], resolve);
            },
          },
          {
            name: "tagMangerPage",
            path: "/tagManage",
            component: (resolve) => {
              require([
                "@/pages/configCenterPage/components/tagManage",
              ], resolve);
            },
          },
          {
            name: "logMangerPage",
            path: "/logManage",
            component: (resolve) => {
              require([
                "@/pages/configCenterPage/components/logManage",
              ], resolve);
            },
          },
        ],
      },

      //区域管理员首页
      {
        name: "areauerPage",
        path: "/areaUer",
        component: (resolve) =>
          require(["../pages/mainPage/areaUser"], resolve),
      },
    ],
  },
];
const routes = home;
const router = new Router({
  mode: 'history',
  // base: '/home/html/',
  base: process.env.BASE_URL,
  routes: routes
})

let that = this

router.beforeEach((to, from, next) => {
  if(to.path=='/imclogin' || to.path=='/disclaimer' || to.path=='/saveRule' || to.path=='/bsLogin' || to.path=='/showpage'){
    next()
  }else if(to.path!='/newlogin' && sessionStorage.getItem('token')==null){
    next("/newlogin")
  }else{

    if(to.path!='/newlogin'){
      let param = {};
      param.method="post";
      param.url="/alert/getRiskLevels";
      param.data={
      }
      Axios2.ajax(param).then((res)=>{
        if (res.resultCode == 0) {
          next()
        } else {
          this.$message.warning(res.resultMessage);
        }

      })
    }else{
      next()
    }

  }




})
export default router;
